type Listener = (...args: unknown[]) => void

class EventEmitter {
  private events: Record<string, Listener[]> = {}

  on(event: string, listener: Listener) {
    if (!this.events[event]) this.events[event] = []
    this.events[event].push(listener)
    return this
  }

  off(event: string, listener: Listener) {
    if (!this.events[event]) return this
    this.events[event] = this.events[event].filter(l => l !== listener)
    return this
  }

  emit(event: string, ...args: unknown[]) {
    if (!this.events[event]) return false
    this.events[event].forEach(listener => listener(...args))
    return true
  }

  removeAllListeners(event?: string) {
    if (event) {
      delete this.events[event]
    } else {
      this.events = {}
    }
    return this
  }
}

const eventEmitter = new EventEmitter()

export default eventEmitter
